var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46 7.51a.539.539 0 01.751-.126l4.19 2.993a.539.539 0 010 .877l-4.19 2.993a.539.539 0 01-.851-.439v-1.391A5.248 5.248 0 00.84 14.418l-.068.067a.474.474 0 01-.595-.006l-.064-.061a.468.468 0 01-.102-.41l.052-.193C.657 11.812 2.782 9.517 5.36 9.23V7.822c0-.112.035-.221.1-.313zM12 0a2 2 0 012 2v9a2 2 0 01-2 2h-1.808l.965-.688c.783-.56.996-1.62.515-2.432l-.087-.133a1.839 1.839 0 00-.308-.334l-.12-.094-4.19-2.993a1.84 1.84 0 00-2.354.182l-.113.12-.098.126c-.19.267-.306.58-.335.905l-.007.163v.357l-.252.083a7.617 7.617 0 00-1.81.929L2 2a2 2 0 012-2h8zM8.5 4h-4a.5.5 0 00-.09.992L4.5 5h4a.5.5 0 000-1zm2-2h-6a.5.5 0 00-.09.992L4.5 3h6a.5.5 0 100-1z",
    fill: "#596168",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default ForwardRef;